var _style, _circle, _circle2, _path, _circle3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconAg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 426.17 434.77",
    style: {
      enableBackground: "new 0 0 426.17 434.77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#6F52EA;stroke:#FFFFFF;stroke-width:30.0045;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2.1432;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 213.09,
    cy: 114.87,
    r: 20.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 213.09,
    cy: 217.67,
    r: 193.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.63,328.12h-5.09c-9.68,0-17.52-7.84-17.52-17.52V167.37c0-9.68,7.84-17.52,17.52-17.52h5.09 c9.68,0,17.52,7.84,17.52,17.52V310.6C233.15,320.28,225.31,328.12,215.63,328.12z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 213.09,
    cy: 104.29,
    r: 20.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconAg);
export default __webpack_public_path__ + "static/media/info-icon-ag.7fe8613b5bba2a6318708f51fd13d065.svg";
export { ForwardRef as ReactComponent };